// extracted by mini-css-extract-plugin
export default {"steps":"AttachFilesFromLinkedCaseDialog_steps__deDbo"};